import { globalData, globalConf } from "@olmokit/core/data";
import { $all, forEach, on } from "@olmokit/dom";
import axios from 'axios';
import "./index.scss";

// //////////
// IMPORTANT:
// some events are intercepted and pushed 
// directly by the route or components js, 
// they are not described here
// //////////

/**
 * Component: Datalayer
 */

if (globalData.route == '404') {
  dataLayer.push({
    "event": "404"
  });
}

export function Datalayer() {
  console.log("Datalayer mounted.");
}

export function dataLayerForm(event, formData, formname, user, request, step?: null | string) {
  dataLayer.push({
    ...formData,
    event: event,
    form: formname,
    user_type: user,
    request_type: request,
    step: step
  });
}

export function salesforceCommunication(formData, formType, user, request) {
  const utmSource = localStorage.getItem('utm_source');
  formData['utmsource'] = utmSource;
  axios.post(globalConf.cmsApiUrl+'/'+globalConf.locale+'/salesforce/access', formData)
  .then(() => {
    console.log('salesforce done');
  })
  .catch((error) => {
    dataLayerForm("salesforce_error", formData, formType, user, request);
    console.log(error);
  });
}

export function dataLayerDowload(collection: string, name: string, action?: string) {
  dataLayer.push({
    'event': 'file_download',
    'category': 'Download',
    'action': action,
    'collection': collection, //'COLLEZIONE DEL PRODOTTO',
    'file_name': name //'NOME FILE SCARICATO'
  });  
}

export function dataLayerFilter(category: string, label: string, action?: string) {
  dataLayer.push({
    'event': 'filter',
    'category': category, // es: Color
    'action': action, //add se aggiunto, remove se rimosso
    'label': label // es: white
  });
}

export function dataLayerMenu(label: string) {
  dataLayer.push({
    'event': 'click',
    'category': 'Menu',
    'action': 'menu_click',
    'label': label
  });
}

export function dataLayerProduct(product: string, collection: string) {
  dataLayer.push({
    'event': 'click',
    'category': 'Product',
    'action': 'product_click',
    'collection': collection, //'COLLEZIONE DEL PRODOTTO',
    'product': product //'NOME PRODOTTO CLICCATO'
  });
}

export function dataLayerStore(category: string, action?: string, label?: string) {
  dataLayer.push({
    'event': 'store_locator',
    'category': category, //'AZIONE FATTA', 
    'action': action, //'STORE CLICCATO',
    'label': label, //'TESTO CLICCATO' // sito, mail o altra info dello store
  });
}

// Not used
export function dataLayerWebinar(webinar: string, action?: string, category?: string) {
  dataLayer.push({
    'event': 'webinar_click',
    'webinar': webinar, //'TITOLO WEBINAR CLICCATO',
    'action': action, //'DOVE è STATO CLICCATO', // click card webinar, calendar
    'pn_category': category, //'CATEGORIA WEBINAR' // product-knowledge, webinar
  });
}

export function dataLayerViewItemList(webinar: string, action?: string, category?: string) {
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    event: "view_item_list", //deve scattare all'impression delle collezioni
    ecommerce: {
      item_list_id: "related_products", // product_listing, related_products, altre liste prodotti presenti nel sito
      item_list_name: "Related products", // Product listing, Related products, altre liste prodotti presenti nel sito
      items: [
       {
        item_id: "SKU_12345", // passiamo il page name perché non mi pare lo abbiamo, oppure l'id prodotto di backend
        item_name: "NOME COLLEZIONE", //es: Liberty
        index: 0, //posizione in elenco
        item_brand: "BRAND",
        item_category: "CATEGORY COLLEZIONE", //es: Porcelain tiles
        item_category2: "EFFETTO COLLEZIONE", //es: concrete
        item_list_id: "related_products", //riprende quella sopra
        item_list_name: "Related Products", //riprende quella sopra
        price: 10, //mettiamo un prezzo fisso fittizio
        quantity: 1
      },
      {
        item_id: "SKU_12346",
        item_name: "NOME COLLEZIONE",
        index: 1,
        item_brand: "BRAND",
        item_category: "CATEGORY COLLEZIONE",
        item_category2: "EFFETTO COLLEZIONE", //es: concrete
        item_list_id: "related_products",
        item_list_name: "Related Products",
        price: 10,
        quantity: 1
      }]
    }
  });
}

//Visualizzazione della collezione
export function dataLayerViewItem(name: string, collection?: string, category?: string, look?: string) {
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    event: "view_item", //deve scattare alla visualizzazione della pagina collezione
    ecommerce: {
      currency: "USD",
      value: 10,
      items: [
        {
          item_id: name, // passiamo il page name perché non mi pare lo abbiamo, oppure l'id prodotto di backend
          item_name: collection, //es: Liberty
          index: 0, // posizione in cui era nell'elenco da cui è stata cliccata
          item_brand: "Atlasconcorde USA",
          item_category: category, //es: Porcelain tiles
          item_category2: look, //es: concrete
          item_list_id: "related_products", // lista da cui era stata cliccata la collezione
          item_list_name: "Related Products", // lista da cui era stata cliccata la collezione
          price: 10,
          quantity: 1
        }
      ]
    }
  });
}

//Click sulla card di collezione
export function dataLayerSelectItem(name: string, category?: string, look?: string, index: string) {
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    event: "select_item", //deve scattare al clic su una collezione
    ecommerce: {
      item_list_id: "related_products", // product_listing, related_products, altre liste prodotti presenti nel sito
      item_list_name: "Related products", // Product listing, Related products, altre liste prodotti presenti nel sito
      items: [
      {
        item_id: name, // passiamo il page name perché non mi pare lo abbiamo, oppure l'id prodotto di backend
        item_name: name, //es: Liberty
        index: index, //posizione in elenco
        item_brand: "Atlasconcorde USA",
        item_category: category, //es: Porcelain tiles
        item_category2: look, //es: concrete
        item_list_id: "related_products", //riprende quella sopra
        item_list_name: "Related Products", //riprende quella sopra
        price: 10,
        quantity: 1
      }
      ]
    }
  });
}

//Download
export function dataLayerPurchase(name: string, category?: string, look?: string, id: string, index: number) {
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    event: "purchase", // deve scattare quando scarico i materiali della collezione
    ecommerce: {
      transaction_id: "string", // dare un'id -> path download
      // Sum of (price * quantity) for all items.
      value: 10,
      tax: 0,
      shipping: 0,
      currency: "USD",
      items: [
      {
        item_id: name, // name
        item_name: name, //"NOME COLLEZIONE", //es: Liberty
        index: index, // posizione in cui era nell'elenco da cui è stata cliccata
        item_brand: "Atlasconcorde USA",
        item_category: category, //"CATEGORY COLLEZIONE", //es: Porcelain tiles
        item_category2: look, //"EFFETTO COLLEZIONE", //es: concrete
        item_list_id: "related_products", // lista da cui è stata cliccata
        item_list_name: "Related Products", // lista da cui è stata cliccata
        price: 10,
        quantity: 1
      }]
    }
  });
}

//Product
export function dataLayerAddToCart(name: string, category?: string, look?: string, color: string, index: number) {
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    event: "add_to_cart", // deve scattare quando si apre il pop up del prodotto della collezione
    ecommerce: {
      currency: "USD",
      value: 10,
      items: [
      {
        item_id: name, //"SKU_12345", // passiamo il page name perché non mi pare lo abbiamo, oppure l'id prodotto di backend
        item_name: name, //"NOME COLLEZIONE", //es: Liberty
        index: index, // posizione in cui era nell'elenco da cui è stata cliccata
        item_brand: "Atlasconcorde USA",
        item_category: category, //"CATEGORY COLLEZIONE", //es: Porcelain tiles
        item_category2: look, //"EFFETTO COLLEZIONE", //es: concrete
        item_list_id: "related_products", // lista da cui è stata cliccata
        item_list_name: "Related Products", // lista da cui è stata cliccata
        item_variant: color, //"COLORE", //es: white
        price: 10,
        quantity: 1
      }
      ]
    }
  });
}


export function ecommerceTackClick() {
  const $elements = $all('.gtmCollectionCard');
  forEach($elements, (el) => {
      on(el, 'click', (e) => {
          const data = el.getAttribute('data-track-impression')
          if(data){
              const dataColl = JSON.parse(data)
              dataLayerViewItem(dataColl.name, dataColl.name, dataColl.category, dataColl.variant)
              // e.preventDefault();
          }
      })
  })  
}